export default {
      id: "estimation-usage",
      viewBox: "0 0 26 22",
      url: __webpack_public_path__ + "sprite.svg#estimation",
      toString: function () {
        return this.url;
      }
    }